import angular from 'angular';
import _ from 'lodash';

class AuditLogCtrl {
    /*@ngInject*/
    constructor($scope, logger, AUDIT, AuditFilter, AuditSvc, KissUserSvc, $translate) {
        this.$scope = $scope;
        this.logger = logger;
        this.AUDIT = AUDIT;
        this.AuditFilter = AuditFilter;
        this.AuditSvc = AuditSvc;
        this.KissUserSvc = KissUserSvc;
        this.$translate = $translate;

        this.gridApi = null;

        // Section recherche
        this.searchOpen = true;
        this.searchData = new this.AuditFilter();

        this.authorId = null;

        this.actions;
    }

    $onInit() {
        var auditData = {};

        var actionTemplate =
            '<div class="ui-grid-cell-contents">{{grid.appScope.$ctrl.getActionToDsiplay(row.entity)}}</div>';

        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'date',
                    displayName: 'audit.col_name.date',
                    headerCellFilter: 'translate',
                    cellFilter: "date:'short'",
                    width: 200,
                    cellClass: 'pointer defaultcursor',
                },
                {
                    name: 'contextId',
                    displayName: 'audit.col_name.context',
                    headerCellFilter: 'translate',
                    width: 200,
                    cellClass: 'pointer defaultcursor',
                },
                {
                    name: 'action',
                    displayName: 'audit.col_name.action',
                    headerCellFilter: 'translate',
                    cellClass: 'pointer defaultcursor',
                    cellTemplate: actionTemplate,
                },
                {
                    name: 'userLogin',
                    displayName: 'audit.col_name.user',
                    headerCellFilter: 'translate',
                    width: 200,
                    cellClass: 'pointer defaultcursor',
                },
            ],
            paginationPageSizes: [100, 500],
            paginationPageSize: this.searchData.pageCriteria.pageSize,
            useExternalPagination: true,
            useExternalSorting: true,
            onRegisterApi: gridApi => this.onRegisterApi(gridApi),
            enableColumnMenus: false,
            enableSorting: true,
            enableGridMenu: false,
            data: auditData.auditLogs,
            totalItems: auditData.totalItems,
        };

        this.searchAction();
        this.search();
    }

    onRegisterApi(gridApi) {
        this.gridApi = gridApi;
        gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => this.sortChanged(grid, sortColumns));
        gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => this.paginationChanged(page, size));
    }

    sortChanged(grid, sortColumns) {
        sortColumns = _.map(sortColumns, col => this.convertSort(col));
        if (sortColumns && sortColumns.length > 0) {
            this.searchData.setSort(sortColumns);
        } else {
            this.searchData.resetSort();
        }
        this.search();
    }

    paginationChanged(page, size) {
        this.searchData.setPageSize(size);
        this.searchData.setPage(page - 1);
        this.search();
    }

    convertSort(col) {
        var columnField = _.find(this.AUDIT.audits.columnFieldMap, {
            field: col.field,
        });
        if (col && col.sort) {
            return {
                direction: angular.uppercase(col.sort.direction),
                property: columnField ? columnField.property : col.field,
                priority: col.sort.priority,
            };
        }
        return {};
    }

    getActionToDsiplay(audit) {
        var actionToDisplay;
        var action = _.find(this.actions, auditAction => auditAction.key === audit.action);
        if (action) {
            actionToDisplay = action.getActionDisplay(audit);
        }
        return actionToDisplay || audit.action;
    }

    /**
     * Fournit la hauteur de la grid en fonction de la taille des pages.
     */
    getGridHeight() {
        var rowHeight = 30;
        return {
            height: this.gridApi.core.getVisibleRows(this.gridApi.grid).length * rowHeight + 81 + 'px',
        };
    }

    search() {
        this.searchData.authorId = this.authorId ? this.authorId.user.id : null;
        var searchResult = this.AuditSvc.searchAudit(this.searchData);
        this.auditPromise = searchResult;
        searchResult.then(
            auditData => {
                this.gridOptions.data = auditData.audits;
                this.gridOptions.totalItems = auditData.totalItems;
            },
            () => this.logger.error('error.search')
        );
    }

    searchAction() {
        var searchResult = this.AuditSvc.getActions();
        this.auditPromise = searchResult;
        searchResult.then(
            auditActionDatas => {
                this.actions = auditActionDatas;
            },
            () => this.logger.error('error.search')
        );
    }

    /**
     * Recherche des auteurs (user) avec autocomplétion.
     */
    searchAuthor(value) {
        if (value && value.length >= 3) {
            return this.KissUserSvc.searchUsersAuto(value).then(users => {
                return users;
            });
        }
    }

    clearForm() {
        // Reset data
        this.searchData = new this.AuditFilter();
        // Reset form
        this.form.$setPristine();
        // Recherche
        this.search();
    }
}

angular.module('app.admin.audit').component('audit', {
    templateUrl: require('./audit.html'),
    controller: AuditLogCtrl,
});
